import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnNetworkData } from './network-data';

export class SnNetworkConfiguration extends SnModel {
  @Expose()
  @Type(() => SnNetworkData)
  public data: SnNetworkData;

  @Expose()
  public status: boolean;
}
